import { render, staticRenderFns } from "./afterSalesOrderDet.vue?vue&type=template&id=0fdcd18c&scoped=true"
import script from "./afterSalesOrderDet.vue?vue&type=script&lang=js"
export * from "./afterSalesOrderDet.vue?vue&type=script&lang=js"
import style0 from "./afterSalesOrderDet.vue?vue&type=style&index=0&id=0fdcd18c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcd18c",
  null
  
)

export default component.exports